import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Tooltip } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";

const SidebarCollection = (props) => {
  const {
    sidebarColActive,
    setsidebarColActive,
    data,
    setFolderId,
    folderId,
    setSubNewFolder,
    setTitle,
    parentCollectionIds,
  } = props;

  return (
    <div
      className={`sidebar-collection-popup ${sidebarColActive ? "active" : ""}`}
    >
      <div className="header">
        <div className="header">
          <p className="col">Folders</p>
          <ArrowBackIcon
            className="hd-ds"
            onClick={() => setsidebarColActive(false)}
          />
        </div>
      </div>
      <div className="tabs-container">
        <div className="tabs">
          <RenderMenuItem
            menuData={data}
            parentCollectionId={0}
            setFolderId={setFolderId}
            folderId={folderId}
            setSubNewFolder={setSubNewFolder}
            setTitle={setTitle}
            parentCollectionIds={parentCollectionIds}
          />
        </div>
      </div>
    </div>
  );
};

function RenderMenuItem(props) {
  const {
    menuData,
    parentCollectionId,
    setFolderId,
    folderId,
    setSubNewFolder,
    setTitle,
    parentCollectionIds,
  } = props;

  const items = menuData.filter(
    (item) => item.parentCollectionID_lng === parentCollectionId
  );
  if (!items.length) return null;
  return items.map((item, id) => (
    <RenderItem
      key={item.collectionID_ids}
      id={id}
      item={item}
      menuData={menuData}
      setFolderId={setFolderId}
      folderId={folderId}
      setSubNewFolder={setSubNewFolder}
      setTitle={setTitle}
      parentCollectionIds={parentCollectionIds}
    />
  ));
}

const RenderItem = ({
  item,
  menuData,
  setFolderId,
  folderId,
  setSubNewFolder,
  setTitle,
  parentCollectionIds,
}) => {
  const [open, setopen] = useState(false);
  const includesParent = parentCollectionIds.includes(item.collectionID_ids);

  function hasNoChildren(collection) {
    const filterChild = menuData.filter(
      (item) => collection.collectionID_ids === item.parentCollectionID_lng
    );
    return filterChild.length === 0;
  }

  const handleClick = (id) => {
    setopen((prevProps) => !prevProps);
    setFolderId(id);
  };

  return (
    <div className={`tabs ${includesParent ? "no-padding" : ""}`}>
      {!includesParent && <div className="vertical-separator"></div>}
      <div
        className={`tab ${
          Number(item.collectionID_ids) === Number(folderId) ? "highlight" : ""
        }`}
        onClick={() => handleClick(item.collectionID_ids)}
      >
        <div className="flex">
          <div className="icon">
            {!hasNoChildren(item) &&
              (open ? <ExpandLessIcon /> : <ExpandMoreIcon />)}{" "}
          </div>
          <p className="flex">
            {item.collectionName_chr}{" "}
            {item.isShared_ysn && <PeopleIcon className="ml-1" />}
          </p>
        </div>

        <div className="end mr-2">
          <Tooltip title="Add New Subfolder">
            <AddIcon
              onClick={() => {
                setTitle(item.collectionName_chr);
                setSubNewFolder(true);
              }}
            />
          </Tooltip>
        </div>
      </div>
      {open && (
        <RenderMenuItem
          menuData={menuData}
          parentCollectionId={item.collectionID_ids}
          setFolderId={setFolderId}
          folderId={folderId}
          setSubNewFolder={setSubNewFolder}
          setTitle={setTitle}
          parentCollectionIds={parentCollectionIds}
        />
      )}
    </div>
  );
};

export default SidebarCollection;
